import React from "react";

import { Chip, ChipProps } from "@mui/material";

export const Status: React.FC<ChipProps> = ({ ...props }) => {
  return <Chip size="medium" {...props} />;
};
